import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'post-checkout',
  setup(__props, { expose }) {
  expose();

const ready = ref(false);
const success = ref(false);

onMounted(() => {
    if(location.hash.includes("success=true")) {
        success.value = true;
    }
    ready.value = true;
});

const __returned__ = { ready, success, ref, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})